import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import FormattedDateTime from '../format/FormattedDateTime';
import color from '../../config/color';
import '../search/SearchEquity.css';

export default class CryptoRow extends Component {
  /*
    This component is a table row showing info about a crypto currency.
    It contains info about a crypto currency and is not related to a user.
  */

  render() {
    const { crypto } = this.props;
    return (
      <tr className="mouse-pointer" onClick={this.props.showModal}>
        <td>{crypto.name}</td>
        <td className="hide-on-500px">
          <FormattedDateTime
            timestamp={crypto.lastUpdatedTimestamp}
            type="Crypto"
            showClockPrefix
          />
        </td>
        <td className={color.getClassName(crypto.dailyChange)}>
          {crypto.dailyChange ? (
            <FormattedNumber // eslint-disable-next-line
              style="percent"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={crypto.dailyChange / 100}
            />
          ) : (
            '-'
          )}
        </td>
        <td>
          {crypto.priceNok ? (
            <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={crypto.priceNok}
            />
          ) : (
            '-'
          )}
        </td>
      </tr>
    );
  }
}

CryptoRow.propTypes = {
  crypto: PropTypes.objectOf(PropTypes.any).isRequired,
  showModal: PropTypes.func.isRequired
};
